import { environment as env } from "../../../environments/environment";

export const SECURITY_ENDPOINTS = {
    login: env.ApiUrl + "oauth/token",
    currentUserInfo: env.ApiUrl + "userinfo/",
    resetPassword: env.ApiUrl + "auth/reset",
    UserInfo: env.ApiUrl + "user/{userId}",
    recoveryRequest: env.ApiUrl + "api/recovery/request",
    isTokenValid: env.ApiUrl + "api/recovery/isValidToken",
};
